import { Grid } from '@material-ui/core';
import React from 'react';
import ReportGijgoGrid from '../ReportsScreens/GijgoForReportsScreen';
import formatters from '../../../Core/Grid/inputFormatter';

const baseColumns = [
    { field: 'lne', sortable: false, title: `LINE`, filterable: false, width: 30 },
    { field: 'opc', sortable: true, title: `OPC`, filterable: false, width: 60 },
    { field: 'description', sortable: true, title: `DESCRIPTION`, filterable: false, width: 240 },
    { field: 'qty', sortable: true, title: `QTY`, align: 'right', filterable: false, width: 30 },
    { field: 'usp', sortable: true, title: `USP`, align: 'right', filterable: false, width: 40 },
    {
        field: 'timeSpent',
        sortable: true,
        title: 'TIME SPENT',
        align: 'right',
        filterable: false,
        width: 40,
        renderer: (val, record) => {
            return record.timeSpent !== undefined ? formatters.ToFixedSeparator(+record.timeSpent) : '';
        }
    },
    {
        field: 'amountInv',
        sortable: true,
        title: 'TIME INVOICED',
        align: 'right',
        filterable: false,
        width: 40,
        renderer: (val, record) => {
            return record.amountInv !== undefined ? record.amountInv : '';
        }
    },
    {
        field: 'amount',
        title: 'AMOUNT',
        align: 'right',
        filterable: false,
        sortable: false,
        width: 40,
        renderer: (val, record) => {
            return record.amount !== undefined ? formatters.CurrencyThousandSeparator(+record.amount) : '';
        }
    }
    // { field: 'ct', title: 'CT', align: 'right', filterable: false, sortable: false, width: 30 },

    // { field: 'davcmopccod', sortable: true, title: `Breakdown`, showColumnTotal: true, align: 'right', filterable: false },
    // { field: 'amount', sortable: true, title: `Amt cst currency`, showColumnTotal: true, align: 'right', filterable: false },
    // { field: 'type', sortable: true, title: 'TYPE', showColumnTotal: true, align: 'center', filterable: false, width: 30 }
    // { field: 'fourMonthsAndOverTotal', sortable: true, title: 'WorkCode', showColumnTotal: true, align: 'right', filterable: false },
    // { field: 'fourMonthsAndOverTotal1', sortable: true, title: 'Corrective des %', showColumnTotal: true, align: 'right', filterable: false },
    // { field: 'unallocatedTotal', title: 'Campaign', showColumnTotal: true, align: 'right', filterable: false, sortable: false }
];
const Labour = (props) => {
    console.log(props, 'ooo');
    return (
        <Grid item container spacing={1} xs={12}>
            <Grid item xs={12}>
                <ReportGijgoGrid
                    // dataConverter={(res) => ({
                    //     records: props.List,
                    //     total: props.List.length
                    // })}
                    localRowsData={props.List}
                    columns={baseColumns}
                    hidePagination={true}
                    hideFilterRow={true}
                />
            </Grid>
        </Grid>
    );
};

export default Labour;
